/**
 * Call source provider
 */
export enum ConnectionProvider {
  THREE_CX = '3cx'
}

export enum ConnectionDirection {
  INCOMING = 'incoming',
  OUTGOING = 'outgoing'
}

export enum ConnectionStatus {
  ONGOING = 'ongoing',
  ANSWERED = 'answered',
  UNANSWERED = 'unanswered'
}

export enum ConnectionLine {
  MAIN = 'main',
  FORWARDED = 'forwarded'
}

/**
 * @path /connectionHistory/$estateId/$connectionId
 * @database shard
 */
export interface ConnectionData {
  id: string;
  /** Unique call id from external provider, used for idempotent upserts */
  externalId: string;
  /** Last common 3CX inbox revision delivered to this history entry. */
  threeCxRevision?: number;
  provider: ConnectionProvider;
  /** Company context resolved for the call */
  companyId: string | null;
  /** Estate context resolved for the call */
  estateId: string | null;
  residentId: string | null;
  /** Snapshot used directly by the search view */
  residentName: string | null;
  residentPhone: string;
  residentPhoneSan: string;
  adminUserId: string | null;
  /** Snapshot used directly by the search view */
  adminName: string | null;
  adminNumber: string;
  adminNumberSan: string;
  line: ConnectionLine;
  direction: ConnectionDirection;
  status: ConnectionStatus;
  createdAt: number;
  endedAt?: number | null;
  durationSec?: number | null;
  recordUrl?: string | null;
  /** Set only when a scheduled fallback closes a call missing its final provider webhook. */
  finalizationTimeoutAt?: number | null;
  notesCount: number;
  lastNoteAt?: number | null;
  lastUpdate: number;
}

/**
 * @path /connectionHistoryNote/$estateId/$connectionId/$noteId
 * @database shard
 */
export interface ConnectionNoteData {
  id: string;
  connectionId: string;
  authorUserId: string | null;
  authorName: string;
  content: string;
  createdAt: number;
  lastUpdate: number;
}
